export default __webpack_public_path__ + "daily_cvr_legend.png";